import { AxiosPrivate } from '../../utils';
import { Proforma, ProformaContent, RelatedTexts, RelatedType } from '../../types';

interface IData {
  data: {
    id: number;
    textType: string;
    content: Proforma;
    related: RelatedTexts;
  };
}

interface IDataSave {
  id: number;
  title: string;
  content: ProformaContent;
}

interface IDataUpdate {
  id: number;
  content: ProformaContent;
}

class ProformasAPI {
  private static instance: ProformasAPI;

  public static getInstance(): ProformasAPI {
    if (!ProformasAPI.instance) {
      ProformasAPI.instance = new ProformasAPI();
    }

    return ProformasAPI.instance;
  }

  getProforma = (stage: string, textType: string) => {
    return AxiosPrivate.get<IData>(`/v1/proformas?stage=${stage}&textType=${textType}`);
  };

  saveProforma = (proforma: IDataSave) => {
    const body = {
      data: {
        title: proforma.title,
        content: proforma.content,
      },
    };

    return AxiosPrivate.post(`/v1/proformas/${proforma.id}/${RelatedType.saved_proformas}`, JSON.stringify(body));
  };

  saveProformaFromSaved = (savedProforma: IDataSave) => {
    const body = {
      data: {
        title: savedProforma.title,
        content: savedProforma.content,
      },
    };

    return AxiosPrivate.post(
      `/v1/${RelatedType.saved_proformas}/${savedProforma.id}/${RelatedType.saved_proformas}`,
      JSON.stringify(body)
    );
  };

  saveExemplar = (proforma: IDataSave) => {
    const body = {
      data: {
        title: proforma.title,
        content: proforma.content,
      },
    };

    return AxiosPrivate.post(`/v1/proformas/${proforma.id}/${RelatedType.saved_exemplars}`, JSON.stringify(body));
  };

  saveExemplarFromSaved = (savedProforma: IDataSave) => {
    const body = {
      data: {
        title: savedProforma.title,
        content: savedProforma.content,
      },
    };

    return AxiosPrivate.post(
      `/v1/${RelatedType.saved_proformas}/${savedProforma.id}/${RelatedType.saved_exemplars}`,
      JSON.stringify(body)
    );
  };

  getSavedProforma = (id: number) => {
    return AxiosPrivate.get<IData>(`/v1/${RelatedType.saved_proformas}/${id}`);
  };

  updateSavedProforma = (savedProforma: IDataUpdate) => {
    const body = {
      data: {
        content: savedProforma.content,
      },
    };

    return AxiosPrivate.put<IData>(`/v1/${RelatedType.saved_proformas}/${savedProforma.id}`, JSON.stringify(body));
  };
}

export const proformasAPI = ProformasAPI.getInstance();
